import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import staticFeedback1 from '../../../../../assets/images/feedback/feedback-1.png';
import staticFeedback2 from '../../../../../assets/images/feedback/feedback-2.png';
import staticFeedback3 from '../../../../../assets/images/feedback/feedback-3.png';
import staticFeedback4 from '../../../../../assets/images/feedback/feedback-4.png';
import feedback1 from '../../../../../assets/images/feedback/feedback-1.gif';
import feedback2 from '../../../../../assets/images/feedback/feedback-2.gif';
import feedback3 from '../../../../../assets/images/feedback/feedback-3.gif';
import feedback4 from '../../../../../assets/images/feedback/feedback-4.gif';

import FeedbackOption from './feedback-option';

import I18n from '@module/i18n';
import TextArea from '@component/form/element/textarea';
import Scrollable from '@component/scrollable';
import Icon from '@component/icon';
import Illustration from '@component/illustration';
import Actions from '@app/action';

const feedbackTypes = [
  {
    message: 'Taking a look',
    staticImageUrl: staticFeedback1,
    imageUrl: feedback1,
  },
  {
    message: 'Got it - thanks',
    staticImageUrl: staticFeedback2,
    imageUrl: feedback2,
  },
  { message: 'Cheers', staticImageUrl: staticFeedback3, imageUrl: feedback3 },
  { message: 'Received', staticImageUrl: staticFeedback4, imageUrl: feedback4 },
];

export class Feedback extends React.PureComponent {
  state = {
    selectedFeedbackTypeIndex: 0,
    feedbackMessage: feedbackTypes[0].message,
    hasMessageChanged: false,
  };
  textareaRef = React.createRef();

  componentDidMount() {
    this.focusTextArea();
  }

  focusTextArea() {
    this.textareaRef &&
      this.textareaRef.current &&
      this.textareaRef.current.focus();
  }

  handleSendEmailClick = () => {
    const { transferId, authorId, sendFeedback } = this.props;
    const { selectedFeedbackTypeIndex, feedbackMessage } = this.state;

    const selectedFeedbackType = feedbackTypes[selectedFeedbackTypeIndex];

    sendFeedback({
      transferId,
      authorId,
      imageUrl: selectedFeedbackType.imageUrl,
      message: feedbackMessage,
    });

    window.__snowplow__ &&
      window.__snowplow__(
        'trackStructEvent:co',
        'feedback',
        'click_send',
        selectedFeedbackType.message.replace(/\s+/g, '_').toLowerCase()
      );
  };

  handleFeedbackMessageChange = (event) => {
    this.setState({
      feedbackMessage: event.target.value,
      hasMessageChanged: true,
    });
  };

  handleFeedbackOptionClick(selectedFeedbackTypeIndex, optionMessage) {
    const { hasMessageChanged, feedbackMessage } = this.state;

    const updatedFeedbackMessage =
      !hasMessageChanged || feedbackMessage.length === 0
        ? optionMessage
        : feedbackMessage;

    const updatedHasMessageChanged =
      feedbackMessage.length === 0 ? false : hasMessageChanged;

    this.setState(
      {
        selectedFeedbackTypeIndex,
        feedbackMessage: updatedFeedbackMessage,
        hasMessageChanged: updatedHasMessageChanged,
      },
      () => {
        this.focusTextArea();
      }
    );
  }

  resetDownloadOnEnter = (event) => {
    if (event.key === 'Enter') {
      this.props.resetDownload();
    }
  };

  render() {
    const { resetDownload, pending } = this.props;
    const { selectedFeedbackTypeIndex, feedbackMessage } = this.state;

    const sendFeedbackButtonClassName = classnames('transfer__button', {
      'transfer__button--inactive': pending.sendFeedback,
    });

    return (
      <div className="transfer__window downloader">
        <div className="transfer__contents">
          <div className="feedback">
            <Scrollable>
              <div className="feedback__content">
                <h2>Reply to sender</h2>
                <Illustration
                  className="feedback__illustration"
                  type={`feedback-${selectedFeedbackTypeIndex + 1}`}
                />
              </div>
              <TextArea
                name="feedback-message"
                value={feedbackMessage}
                onChange={this.handleFeedbackMessageChange}
                label="Message"
                className="feedback__message"
                textareaElementClassName="feedback__message-content"
                textareaRef={this.textareaRef}
              />
            </Scrollable>
            <div className="feedback__options">
              {feedbackTypes.map(({ message, staticImageUrl }, index) => (
                <FeedbackOption
                  key={message}
                  onClick={this.handleFeedbackOptionClick.bind(
                    this,
                    index,
                    message
                  )}
                  message={message}
                  imageUrl={staticImageUrl}
                  selected={selectedFeedbackTypeIndex === index}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="transfer__footer">
          <Icon
            type="TransferBack"
            className="transfer__back"
            onClick={resetDownload}
            onKeyDown={this.resetDownloadOnEnter}
            label={I18n.t('transfer.buttons.go_to_transfer')}
          />
          <button
            className={sendFeedbackButtonClassName}
            onClick={this.handleSendEmailClick}
          >
            Send
          </button>
        </div>
      </div>
    );
  }
}

Feedback.propTypes = {
  resetDownload: PropTypes.func.isRequired,
  sendFeedback: PropTypes.func.isRequired,
  pending: PropTypes.shape({ sendFeedback: PropTypes.bool }),
  transferId: PropTypes.string.isRequired,
  authorId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ pending, transfer }) => ({
  pending,
  transferId: transfer.id,
  authorId: transfer.recipient_id,
});

const mapDispatchToProps = {
  resetDownload: Actions.Transfer.resetDownload,
  sendFeedback: Actions.Transfer.sendFeedback,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Feedback);
